// @flow
import React, { Component } from "react";
import { Row, Col, Form, Modal, Input, Select } from "antd";

const FormItem = Form.Item;
const Option = Select.Option;

class Phone extends Component {
    

  onSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        return;
      }
      this.props.onSave(values);
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      visible,
      onCancel,
      phone,
      onChangeCategory,
      onChangeNumber
    } = this.props;

    return (
      <Modal
        title={phone.is_exist ? "Редактирование телефона" : "Новый телефон"}
        width={650}
        destroyOnClose
        visible={visible}
        onOk={this.onSubmit}
        onCancel={onCancel}
      >
        <Form layout={"vertical"}>
          <Row gutter={{ md: 8, lg: 24, xl: 48 }}>
            <Col xs={24} sm={24} md={24} lg={8} xl={8}>
              <FormItem label={"Тип"}>
                {getFieldDecorator("category", {
                  onChange: onChangeCategory,
                  initialValue: phone.category
                })(
                  <Select
                    style={{ width: "100%" }}
                    placeholder="Тип"
                    optionFilterProp="children"
                    filterOption={false}
                  >
                    <Option value={"mobile"}>мобильный</Option>
                    <Option value={"work"}>рабочий</Option>
                    <Option value={"fax"}>факс</Option>
                  </Select>
                )}
              </FormItem>
            </Col>

            <Col sm={{ span: 24 }} md={{ span: 16 }} xs={{ span: 16 }}>
              <FormItem label={"Номер"}>
                {getFieldDecorator("number", {
                  onChange: onChangeNumber,
                  initialValue: phone.number
                })(<Input />)}
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(Phone);
